// extracted by mini-css-extract-plugin
export default {"wrap":"index_wrap_Ski-r clearfix","current":"index_current_IrUnX"};